import Dropdown from '@ui/dropdown'
import DropdownItem from '@ui/dropdown/dropdown-item'
import DropdownItemInner from '@ui/dropdown/dropdown-item-inner'
import DropdownSubMenu from '@ui/dropdown/dropdown-submenu'
import enFlag from '@assets/images/flags/en.svg'
import deFlag from '@assets/images/flags/de.svg'
import Anchor from '@ui/anchor'
import cn from 'classnames'
import { LanguageWrap, FlagWrap } from './style'
import { usePageContext } from '@context/PageContext'

const langs = [
  {
    code: 'de',
    flag: deFlag
  },
  {
    code: 'en',
    flag: enFlag
  }
]

const Language = ({ className, ...props }) => {
  const { locale: currentLocale, pageLocales } = usePageContext()

  const availableLanguages = []
  langs.forEach((lang) => {
    if (pageLocales && lang.code in pageLocales) {
      availableLanguages.push(lang)
    }
  })

  let queryParams = ''
  if (typeof window !== 'undefined') {
    queryParams = window.location.search
  }

  availableLanguages.forEach((lang) => {
    lang.pagePath = `/${lang.code}/${pageLocales[lang.code]}${queryParams}`
    lang.isActive = currentLocale === lang.code
  })

  const activeLanguage = availableLanguages.find((el) => {
    return el.isActive
  })
  if (!activeLanguage) {
    return null
  }

  const inActiveLanguage = availableLanguages.filter((el) => {
    return !el.isActive
  })

  const canSwitchLanguage = inActiveLanguage.length !== 0

  return (
    <LanguageWrap className={cn(className, 'lang-switcher')} {...props}>
      <Dropdown>
        <DropdownItem active={canSwitchLanguage}>
          <DropdownItemInner active={canSwitchLanguage}>
            <FlagWrap>
              <img src={activeLanguage.flag} alt={activeLanguage.code} />
            </FlagWrap>
            <span>{activeLanguage.code}</span>
          </DropdownItemInner>
          <DropdownSubMenu>
            {inActiveLanguage.map((lang, index) => {
              return (
                <DropdownItem key={index}>
                  <Anchor path={lang.pagePath}>
                    <DropdownItemInner>
                      <FlagWrap>
                        <img src={lang.flag} alt={lang.code} />
                      </FlagWrap>
                      <span>{lang.code}</span>
                    </DropdownItemInner>
                  </Anchor>
                </DropdownItem>
              )
            })}
          </DropdownSubMenu>
        </DropdownItem>
      </Dropdown>
    </LanguageWrap>
  )
}

export default Language
